import React from "react";
import { useSelector } from "react-redux";

import PatientEvaluationsReports from "../index";
import RofReports from "../../rof_report";

const ReportSwitch = (props) => {
  const canAssignFallRisk = useSelector(
    s => s.institutions?.current_institution?.package_plan_id === 5 ?? false
  );

  // Treat undefined/null as loading: keep ROF report (prevents flash to old page)
  if (canAssignFallRisk == null) return <RofReports {...props} />;

  return canAssignFallRisk ? <RofReports {...props} /> : <PatientEvaluationsReports {...props} />;
};

export default ReportSwitch;
